import { Button, Heading, Paragraph } from '@digdir/designsystemet-react';
import { useTranslation } from 'react-i18next';
import { FC } from 'react';

import { SummaryCard } from '../../../expertRegistration/json/common/summary/styledComponents';
import {
  useGetUnofficialEnergyCertificate,
  useGetUnofficialEnergyCertificateFlerbolig
} from '../../../../hooks/useGetUnofficialEnergyCertificate';
import { ButtonWrapper } from '../solceller/form/components/styledComponents';
import { EkspertInndata } from '../../../../types/expertToolsJSON';

interface Props {
  registrationId?: string;
  flerboligId?: string;
  ekspertInndata?: EkspertInndata;
}
export const Preview: FC<Props> = ({ registrationId, flerboligId, ekspertInndata }) => {
  const { t } = useTranslation('', { keyPrefix: 'form.samtykke.maalform' });
  const certificate = useGetUnofficialEnergyCertificate(registrationId, ekspertInndata);
  const certificateFlerbolig = useGetUnofficialEnergyCertificateFlerbolig(flerboligId, ekspertInndata);

  if (!registrationId && !flerboligId) {
    return null;
  }

  const { getCertificate, isLoading } = registrationId ? certificate : certificateFlerbolig;

  return (
    <SummaryCard>
      <Heading level={4}>{t('preview')}</Heading>
      <Paragraph data-size="sm">{t('description')}</Paragraph>
      <ButtonWrapper>
        <Button loading={isLoading} type="button" variant="secondary" onClick={getCertificate}>
          {t('preview')}
        </Button>
      </ButtonWrapper>
    </SummaryCard>
  );
};
